import { render, staticRenderFns } from "./BuildingDialog.vue?vue&type=template&id=19622744&scoped=true&"
import script from "./BuildingDialog.vue?vue&type=script&lang=js&"
export * from "./BuildingDialog.vue?vue&type=script&lang=js&"
import style0 from "./BuildingDialog.vue?vue&type=style&index=0&id=19622744&scoped=true&lang=scss&"
import style1 from "./BuildingDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19622744",
  null
  
)

export default component.exports